import { takeEvery, fork, put, all, call, takeLatest, delay } from "redux-saga/effects";

// Login Redux States
import { ChatsActionTypes } from "./types";
import {
  chatsApiResponseSuccess, chatsApiResponseError
} from "./actions";
import {
  getContentUnreadCount as getContentUnreadCountAction,
  getAllContentCount as getAllContentCountAction,
} from "./actions";

import { updateUnreadCount as sl2_updateUnreadCount } from "../chats/slice";

import {
  getFavourites as getFavouritesApi,
  getDirectMessages as getDirectMessagesApi,
  getChannels as getChannelsApi,
  addContacts as addContactsApi,
  createChannel as createChannelApi,
  getChatUserDetails as getChatUserDetailsApi,
  getChatUserDetails2s as getChatUserDetails2sApi,
  getLastGroupChatInfoOfMember as getLastGroupChatInfoOfMemberApi,
  delUserFromGroup as delUserFromGroupApi,
  addUserToGroup as addUserToGroupApi,
  viewMsgMember as viewMsgMemberApi,
  getChatUserConversations as getChatUserConversationsApi,
  getChatUserConversationsPrev as getChatUserConversationsPrevApi,
  getChatUserConversationsNext as getChatUserConversationsNextApi,
  sendMessage,
  receiveMessage as receiveMessageApi,
  readMessage as readMessageApi,
  receiveMessageFromUser as receiveMessageFromUserApi,
  deleteMessage as deleteMessageApi,
  forwardMessage as forwardMessageApi,
  deleteUserMessages as deleteUserMessagesApi,
  getChannelDetails as getChannelDetailsApi,
  toggleFavouriteContact as toggleFavouriteContactApi,
  getArchiveContact as getArchiveContactApi,
  toggleArchiveContact as toggleArchiveContactApi,
  readConversation as readConversationApi,
  deleteImage as deleteImageApi,

  // getChatRoomLists as getChatRoomListsApi,
  loadCustomerContent as loadCustomerContentApi,
  getContentUnreadCount as getContentUnreadCountApi,
  getAllContentUnreadCount as getAllContentUnreadCountApi,
  getContentList as getContentListApi,
  setRespEmoji as setRespEmojiApi,
  erpGetCustomerTask as erpGetCustomerTaskApi,
  erpGetPrevTopNoVolume as erpGetPrevTopNoVolumeApi,
  erpCateSizeNotSaleMoreThan45 as erpCateSizeNotSaleMoreThan45Api,
  erpCateInterestNotSale as erpCateInterestNotSaleApi,
  erpCateNotSaleMoreThan60 as erpCateNotSaleMoreThan60Api,

  findForFilterChatRoom as findForFilterChatRoomApi,
  searchChat as searchChatApi,
  quickReplyLoadAllApi,
  UserTypes,
} from "../../api/index";

import {
  showSuccessNotification,
  showErrorNotification,
} from "../../helpers/notifications";

//actions
import {
  getDirectMessages as getDirectMessagesAction,
  getFavourites as getFavouritesAction,
  getChannels as getChannelsAction,
  erpGetCustomerTask as erpGetCustomerTaskAction,
  erpGetPrevTopNoVolume as erpGetPrevTopNoVolumeAction,
  erpCateSizeNotSaleMoreThan45 as erpCateSizeNotSaleMoreThan45Action,
  erpCateInterestNotSale as erpCateInterestNotSaleAction,
  erpCateNotSaleMoreThan60 as erpCateNotSaleMoreThan60Action,

} from "./actions";
import { useReducedMotion } from "framer-motion";
import { useRedux } from "hooks";
import { createSelector } from "reselect";
import { StorageUtils, Utils } from "helpers/utils";
import { API_MESSAGE } from "api/apiCore";
import { Console } from "console";


function* getFavourites() {
  try {
    const response: Promise<any> = yield call(getFavouritesApi);
    // console.log(response);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.GET_FAVOURITES, response)
    );
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.GET_FAVOURITES, error));
  }
}


// USE NEW VERSION INSTEAD
// function* getChatRoomLists() {
//   try {
//     //const response: Promise<any> = yield call(getChatRoomListsApi);
//     // const response: any[] = yield call(getChatRoomListsApi);
//     // var companies = new Array();
//     // if (response){
//     //   for (var i=0;i<response.length;++i){
//     //     companies.push({
//     //       id: response[i].id,
//     //       name: response[i].name,
//     //     });
//     //   }
//     // }
//     // let activeCompanyGroup = StorageUtils.GetActiveChatRoomCompany();
//     // if (response) {
//     //   let foundActive = false;
//     //   for (var i = 0; i < response.length; ++i) {
//     //     if (activeCompanyGroup == -1 && i == 0) activeCompanyGroup = response[i].id;
//     //     console.log([activeCompanyGroup, response[i].id]);
//     //     response[i].isActiveCompany = activeCompanyGroup == response[i].id;
//     //     if (response[i].isActiveCompany) foundActive = true;
//     //   }
//     //   if (foundActive == false && response.length > 0){
//     //     activeCompanyGroup = response[0].id;
//     //     response[0].isActiveCompany = true;
//     //   }
//     //   if (activeCompanyGroup != StorageUtils.GetActiveChatRoomCompany()){
//     //     StorageUtils.SetActiveChatRoomCompany(activeCompanyGroup);
//     //   }
//     // }

//     // console.log('getChatRoomLists:', response);
//     yield put(
//       chatsApiResponseSuccess(ChatsActionTypes.GET_CHAT_ROOM_LIST, response)
//     );
//   } catch (error: any) {
//     yield put(chatsApiResponseError(ChatsActionTypes.GET_CHAT_ROOM_LIST, error));
//   }
// }

function* loadCustomerContent({ payload: groupId }: any) {
  try {
    //const response: Promise<any> = yield call(loadCustomerContentApi, groupId);
    const response: any[] = yield call(loadCustomerContentApi, groupId);
    // console.log('loadCustomerContent:', response);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.LOAD_CUSTOMER_CONTENT, response));
    yield put(getAllContentCountAction(groupId)); // dispatch other action to get content count

    /* bellow is load content unread one by one    
        // Loop through the response array to handle UnreadCount === -1
        for (const item of response) {
          // console.log('each content:', item);
          for (const title of item.contentTitles) {
            // console.log('each title:', title);
            if (title.displayUnread && title.unreadCount === -1 && title.titleName == "ข่าวสาร") {
              // Dispatch an action or call a saga to fetch the unread count for this item
              //console.log('call api get content unread:', groupId, title.contentTitleId);
              yield put(getContentUnreadCountAction(groupId, title.contentTitleId));
              // yield put({
              //   type: ChatsActionTypes.FETCH_UNREAD_COUNT,
              //   payload: { id: item.id } // Replace 'id' with the correct identifier property
              // });
            }
          }
        }
          */
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.LOAD_CUSTOMER_CONTENT, error));
  }
}

function* getAllContentCount({ payload: { userOrGroupId } }: any) {
  try {
    const response: Promise<any> = yield call(getAllContentUnreadCountApi, userOrGroupId);
    // console.log('function* getContentUnreadCount result : ', response);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.GET_CONTENT_UNREAD_COUNT_ALL, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.GET_CONTENT_UNREAD_COUNT_ALL, error));
  }
}

function* getContentUnreadCount({ payload: { userOrGroupId, titleId } }: any) {
  try {
    //console.log('function* getContentUnreadCount : ', { userOrGroupId, titleId });
    const response: Promise<any> = yield call(getContentUnreadCountApi, userOrGroupId, titleId);
    // console.log('function* getContentUnreadCount result : ', response);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.GET_CONTENT_UNREAD_COUNT, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.GET_CONTENT_UNREAD_COUNT, error));
  }
}

function* setRespEmoji({ payload: { msgId, emojiName, emojiSymbol, currentMemberName } }: any) {
  try {
    //console.log('function* setRespEmoji:', msgId, emojiName, emojiSymbol, currentMemberName);
    const response: Promise<any> = yield call(setRespEmojiApi, msgId, emojiName, emojiSymbol);
    // yield put(chatsApiResponseSuccess(ChatsActionTypes.SET_RESP_EMOJI, response)); -> no set, because already set once click set emoji
  } catch (error: any) {
    console.error(error);
  }
}

function* getDirectMessages() {
  try {
    const response: Promise<any> = yield call(getDirectMessagesApi);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.GET_DIRECT_MESSAGES, response)
    );
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.GET_DIRECT_MESSAGES, error)
    );
  }
}

function* getChannels() {
  try {
    const response: Promise<any> = yield call(getChannelsApi);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.GET_CHANNELS, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.GET_CHANNELS, error));
  }
}

function* addContacts({ payload: contacts }: any) {
  try {
    const response: Promise<any> = yield call(addContactsApi, contacts);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ADD_CONTACTS, response));
    yield call(showSuccessNotification, response + "");
  } catch (error: any) {
    yield call(showErrorNotification, error);
    yield put(chatsApiResponseError(ChatsActionTypes.ADD_CONTACTS, error));
  }
}
function* createChannel({ payload: channelData }: any) {
  try {
    const response: Promise<any> = yield call(createChannelApi, channelData);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.CREATE_CHANNEL, response)
    );
    yield call(showSuccessNotification, response + "");
  } catch (error: any) {
    yield call(showErrorNotification, error);
    yield put(chatsApiResponseError(ChatsActionTypes.CREATE_CHANNEL, error));
  }
}

function* getChatUserDetails({ payload: id }: any) {
  try {
    const response: Promise<any> = yield call(getChatUserDetailsApi, id);
    // console.log('getChatUserDetails',response);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.GET_CHAT_USER_DETAILS, response)
    );
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.GET_CHAT_USER_DETAILS, error)
    );
  }
}

function* getChatUserDetails2s({ payload: { selectedChat, addToChatRoomList, loadProfile, loadErp } }: any) {
  try {
    const id = selectedChat;
    if (loadProfile) {
      if (id) {
        // console.log('saga.getChatUserDetails2s load profile of ' + id);
        const response: Promise<any> = yield call(getChatUserDetails2sApi, id);
        yield put(
          chatsApiResponseSuccess(ChatsActionTypes.GET_CHAT_USER_DETAILS_2S, { response: response, addToChatRoomList: addToChatRoomList })
        );
        const r2 = response as any;
        yield put(sl2_updateUnreadCount({
          userId: r2.userGroupId,
          unreadCount: r2.unreadCount,
          unreadTagMe: r2.unreadTagMe,
          lastChatText: r2.lastChatText,
          lastChatTime: r2.lastChatTime
        }))
      } else {
        // console.log('saga.getChatUserDetails2s load profile of ' + id);
        yield put(
          chatsApiResponseSuccess(ChatsActionTypes.GET_CHAT_USER_DETAILS_2S, { response: [], addToChatRoomList: addToChatRoomList })
        );
        yield put(sl2_updateUnreadCount({
          userId: -1,
          unreadCount: 0,
          unreadTagMe: 0,
          lastChatText: "",
          lastChatTime: ""
        }))
      }
    }

    //if ((response as any).loggedInUserType == UserTypes.Employee) {
    if (loadErp) {
      // console.log('saga.getChatUserDetails2s load ERP of ' + id);
      yield put(erpGetCustomerTaskAction(id));
      yield put(erpGetPrevTopNoVolumeAction(id));
      yield put(erpCateSizeNotSaleMoreThan45Action(id));
      yield put(erpCateInterestNotSaleAction(id));
      yield put(erpCateNotSaleMoreThan60Action(id));
    }
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.GET_CHAT_USER_DETAILS_2S, error)
    );
  }
}

function* getLastGroupChatInfoOfMember({ payload: { userOrGroupId } }: any) {
  try {
    const response: Promise<any> = yield call(getLastGroupChatInfoOfMemberApi, userOrGroupId);
    // console.log('response:', response);
    const r2 = response as any;
    yield put(sl2_updateUnreadCount({
      userId: r2.userGroupId,
      unreadCount: r2.unreadCount,
      unreadTagMe: r2.unreadTagMe,
      lastChatText: r2.lastChatText,
      lastChatTime: r2.lastChatTime
    }))
  } catch (error: any) {
    console.error(error);
  }
}

function* erpGetCustomerTask({ payload: { userOrGroupId } }: any) {
  try {
    // console.log('saga erpGetCustomerTask:', { userOrGroupId });
    const response: Promise<any> = yield call(erpGetCustomerTaskApi, userOrGroupId);
    // console.log('erpGetCustomerTask:', response);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_GET_CUSTOMER_TASK, response));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_GET_CUSTOMER_TASK, null));
  }
}

function* erpGetPrevTopNoVolume({ payload: { userOrGroupId } }: any) {
  try {
    const response: Promise<any> = yield call(erpGetPrevTopNoVolumeApi, userOrGroupId);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_GET_PREV_TOP_NO_VOLUME, response));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_GET_PREV_TOP_NO_VOLUME, null));
  }
}


function* erpCateSizeNotSaleMoreThan45({ payload: { userOrGroupId } }: any) {
  try {
    const response: Promise<any> = yield call(erpCateSizeNotSaleMoreThan45Api, userOrGroupId);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45, response));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45, null));
  }
}
function* erpCateInterestNotSale({ payload: { userOrGroupId } }: any) {
  try {
    const response: Promise<any> = yield call(erpCateInterestNotSaleApi, userOrGroupId);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_CATE_INTEREST_NOT_SALE, response));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_CATE_INTEREST_NOT_SALE, null));
  }
}
function* erpCateNotSaleMoreThan60({ payload: { userOrGroupId } }: any) {
  try {
    const response: Promise<any> = yield call(erpCateNotSaleMoreThan60Api, userOrGroupId);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_CATE_NOT_SALE_MORE_THAN_60, response));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ERP_CATE_NOT_SALE_MORE_THAN_60, null));
  }
}


function* findForFilterChatroom({ type, payload: { notYetRead, personUnRead, noActivity, keywordMode, topRow, keyword } }: any) {
  try {
    // console.log('function* findForFilterChatroom:', { type, notYetRead, personUnRead, noActivity, keywordMode, keyword });
    const response: Promise<any> = yield call(findForFilterChatRoomApi, notYetRead, personUnRead, noActivity, keywordMode, topRow, keyword);
    // console.log('response:', response);
    yield put(chatsApiResponseSuccess(type/*ChatsActionTypes.FIND_FOR_FILTER_CHATROOM*/, { keywordMode, response }));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(type/*ChatsActionTypes.FIND_FOR_FILTER_CHATROOM*/, null));
  }
}

function* searchChat({ type, payload: { userOrGroupId, page, keyword } }: any) {
  try {
    console.log('searchChat:', { type, userOrGroupId, page, keyword });
    // console.log('function* findForFilterChatroom:', { type, notYetRead, personUnRead, noActivity, keywordMode, keyword });
    const response: Promise<any> = yield call(searchChatApi, userOrGroupId, page, keyword);
    console.log('searchChatRs:', response);
    yield put(chatsApiResponseSuccess(type/*ChatsActionTypes.FIND_FOR_FILTER_CHATROOM*/, response));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(type/*ChatsActionTypes.FIND_FOR_FILTER_CHATROOM*/, null));
  }
}

function* quickReplyLoadAll({ type, payload: { } }: any) {
  try {
    // console.log('quickReplyLoadAll(saga):');
    // console.log('function* findForFilterChatroom:', { type, notYetRead, personUnRead, noActivity, keywordMode, keyword });
    const response: Promise<any> = yield call(quickReplyLoadAllApi);
    // console.log('quickReplyLoadAll(rs):', response);
    yield put(chatsApiResponseSuccess(type/*ChatsActionTypes.FIND_FOR_FILTER_CHATROOM*/, response));
  } catch (error: any) {
    yield put(chatsApiResponseSuccess(type/*ChatsActionTypes.FIND_FOR_FILTER_CHATROOM*/, null));
  }
}

function* delUserFromGroup({ payload: { groupId, memberId } }: any) {
  try {
    // console.log('saga delUserFromGroup:',{ groupId, memberId });
    const response: Promise<any> = yield call(delUserFromGroupApi, groupId, memberId);
    // console.log('response:', response);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.DEL_USER_FROM_GROUP, response)
    );
  } catch (error: any) {
    Utils.HandleException(error, true);
    yield put(
      chatsApiResponseError(ChatsActionTypes.DEL_USER_FROM_GROUP, error)
    );
  }
}

function* addUserToGroup({ payload: { groupId, memberId, isAdd } }: any) {
  try {
    // console.log('saga delUserFromGroup:',{ groupId, memberId });
    const response: Promise<any> = yield call(addUserToGroupApi, groupId, memberId, isAdd);
    // console.log('response:', response);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.ADD_USER_TO_GROUP, { response, groupId, memberId, isAdd })
    );
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.ADD_USER_TO_GROUP, error)
    );
  }
}

function* viewMsgMember({ payload: { msgId } }: any) {
  try {
    if (msgId) {
      //console.log('msgId:', msgId);
      const response: Promise<any> = yield call(viewMsgMemberApi, msgId);
      // console.log('response:', response);
      yield put(
        chatsApiResponseSuccess(ChatsActionTypes.VIEW_MSG_MEMBER, response)
      );
    }
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.VIEW_MSG_MEMBER, error)
    );
  }
}

// function* setTypingText({ payload: {selectedChat, typingText} } : any) {
//   console.log('setTypingText(saga):', {selectedChat, typingText});
//    try {
//      yield put(chatsApiResponseSuccess(ChatsActionTypes.SET_TYPING_TEXT, {selectedChat, typingText}));
//    } catch (error: any) {
//   //   yield put(chatsApiResponseError(ChatsActionTypes.SET_TYPING_TEXT, error));
//    }
// }

function* getChatUserConversationsPrev({ payload: { id, minDateTime } }: any) {
  try {
    // console.log('function* getChatUserConversationsPrev:', { id, minDateTime });
    const response: Promise<any> = yield call(getChatUserConversationsPrevApi, id, minDateTime);
    (response as any)?.messages?.forEach((ee: any) => {
      ee.htmlContent = Utils.ChangePdfLinkHref(ee.htmlContent);
    })
    yield put(chatsApiResponseSuccess(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_PREV, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_PREV, error));
  }
}

function* getChatUserConversationsNext({ payload: { id, maxDateTime } }: any) {
  try {
    // console.log('function* getChatUserConversationsNext:', { id, maxDateTime });
    const response: Promise<any> = yield call(getChatUserConversationsNextApi, id, maxDateTime);
    (response as any)?.messages?.forEach((ee: any) => {
      ee.htmlContent = Utils.ChangePdfLinkHref(ee.htmlContent);
    })
    yield put(chatsApiResponseSuccess(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_NEXT, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_NEXT, error));
  }
}

function* getContentList({ payload: { userOrGroupId, selectedContentTitle } }: any) {
  try {
    if (selectedContentTitle != null) {
      //console.log('function* getChatUserConversationsNext:', { id, maxDateTime });
      const response: Promise<any> = yield call(getContentListApi, userOrGroupId, selectedContentTitle);
      // console.log('getContentList:', response);
      yield put(chatsApiResponseSuccess(ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE, response));
    } else {
      yield put(chatsApiResponseSuccess(ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE, null));
    }
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE, error));
  }
}

function* getChatUserConversations({ payload: { id, sendDateTime, direction, isFromSearch, searchMsgId, markAllAsRead, callFrom } }: any) {
  try {
    // console.log('getChatUserConversations saga : ', { id, sendDateTime, direction, isFromSearch, callFrom });
    let response: Promise<any> = yield call(getChatUserConversationsApi, id, sendDateTime, direction, isFromSearch, markAllAsRead);
    // console.log('getChatUserConversations 1 : done:', response);
    (response as any)?.messages?.forEach((ee: any) => {
      ee.htmlContent = Utils.ChangePdfLinkHref(ee.htmlContent);
    })

    if (isFromSearch) {
      (response as any).searchMsgId = searchMsgId;
      // console.log(response);
    }

    yield put(
      chatsApiResponseSuccess(
        ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS,
        response
      )
    );
  } catch (error: any) {
    //console.log('get conversion error because not login:', error);
    if (error == API_MESSAGE.INVALID_CREDENTIALS_401 || (error as Error).message == API_MESSAGE.INVALID_CREDENTIALS_401) {
      const dummy = {
        "conversationId": id,
        "userId": -1,
        "messages": [
          {
            "mId": "b4833acb-edaf-4ca1-bab0-f98656e96b8e",
            "text": "ยังไม่ได้ล็อกอิน",
            "senderId": -1,
            "isFromMe": false,
            "senderName": 'BOT',
            "senderPictureUrl": "/icons/chatbot.png",
            "time": Utils.GetCurrentDateTimeLongFormat(),
            "meta": {
              "receiver": -1,
              "sender": -1,
              "senderName": "BOT",
              "sent": true,
              "received": true,
              "read": true,
              "isForwarded": false,
              "userData": {
                "userId": 0,
                "userType": 0,
                "isAdmin": false,
                "registerId": null,
                "authLineId": null,
                "authMobileNo": null,
                "firstName": "hahahah",
                "lastName": "jigjig",
                "fullName": null,
                "nickName": null,
                "companyName": null,
                "pictureUrl": "/icons/chatbot.png",
                "inActiveDate": null,
                "inActiveReason": null,
                "isReceiptance": null,
                "lastLogonDate": null,
                "groupInviteCode": null,
                "groupInviteOn": null,
                "activeGroupId": null,
                "lastConnectDate": null,
                "profileImage": "/icons/chatbot.png",
                "isActive": true,
                "chats": [],
                "createDate": null,
                "updateDate": null,
                "createBy": null,
                "updateBy": null
              }
            },
            "conversationId": id,
            "conversion": null
          }
        ]
      }
      //console.log(dummy);
      yield put(
        chatsApiResponseSuccess(
          ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS,
          dummy
        )
      );
    } else {
      yield put(
        chatsApiResponseError(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS, error)
      );
    }
  }
}

function* onSendMessage({ payload: data }: any) {
  try {
    const response: Promise<any> = yield call(sendMessage, data);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.ON_SEND_MESSAGE, response)
    );
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.ON_SEND_MESSAGE, error));
  }
}

function* receiveMessage({ payload: id }: any) {
  try {
    const response: Promise<any> = yield call(receiveMessageApi, id);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.RECEIVE_MESSAGE, response)
    );
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.RECEIVE_MESSAGE, error));
  }
}

function* readMessage({ payload: id }: any) {
  try {
    const response: Promise<any> = yield call(readMessageApi, id);
    yield put(chatsApiResponseSuccess(ChatsActionTypes.READ_MESSAGE, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.READ_MESSAGE, error));
  }
}

function* deleteMessage2s({ payload: id }: any) {
  try {
    //const response: Promise<any> = yield call(readMessageApi, id);
    const response = {
      id: id
    };
    yield put(chatsApiResponseSuccess(ChatsActionTypes.DELETE_MESSAGE_2S, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.DELETE_MESSAGE_2S, error));
  }
}




function* addMessage2s({ payload: payload }: any) {
  try {
    const data = payload.data;
    const addType = payload.addType;
    yield put(chatsApiResponseSuccess(ChatsActionTypes.ADD_MESSAGE_2S, payload));

    // Indicate the operation is complete
    //yield delay(1000); // 20251007 uncomment, cannot remember why put this delay before.
    yield put({ type: ChatsActionTypes.ADD_MESSAGE_2S_SUCCESS });

  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.ADD_MESSAGE_2S, error));
  }
}

function* receiveMessageFromUser({ payload: id }: any) {
  try {
    const response: Promise<any> = yield call(receiveMessageFromUserApi, id);
    yield put(
      chatsApiResponseSuccess(
        ChatsActionTypes.RECEIVE_MESSAGE_FROM_USER,
        response
      )
    );
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.RECEIVE_MESSAGE_FROM_USER, error)
    );
  }
}

function* deleteMessage({ payload: { userId, messageId } }: any) {
  try {
    const response: Promise<any> = yield call(
      deleteMessageApi,
      userId,
      messageId
    );
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.DELETE_MESSAGE, response)
    );
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.DELETE_MESSAGE, error));
  }
}

function* forwardMessage({ payload: data }: any) {
  try {
    const response: Promise<any> = yield call(forwardMessageApi, data);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.FORWARD_MESSAGE, response)
    );
    yield call(showSuccessNotification, response + "");
  } catch (error: any) {
    yield call(showErrorNotification, error + "");
    yield put(chatsApiResponseError(ChatsActionTypes.FORWARD_MESSAGE, error));
  }
}

function* deleteUserMessages({ payload: userId }: any) {
  try {
    const response: Promise<any> = yield call(deleteUserMessagesApi, userId);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.DELETE_USER_MESSAGES, response)
    );
    yield call(showSuccessNotification, response + "");
  } catch (error: any) {
    yield call(showErrorNotification, error + "");
    yield put(
      chatsApiResponseError(ChatsActionTypes.DELETE_USER_MESSAGES, error)
    );
  }
}

function* getChannelDetails({ payload: id }: any) {
  try {
    const response: Promise<any> = yield call(getChannelDetailsApi, id);
    //console.log('getChannelDetails', response);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.GET_CHANNEL_DETAILS, response)
    );
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.GET_CHANNEL_DETAILS, error)
    );
  }
}

function* toggleFavouriteContact({ payload: id }: any) {
  try {
    const response: Promise<any> = yield call(toggleFavouriteContactApi, id);
    yield put(
      chatsApiResponseSuccess(
        ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT,
        response
      )
    );
    yield call(showSuccessNotification, response + "");
  } catch (error: any) {
    yield call(showErrorNotification, error + "");
    yield put(
      chatsApiResponseError(ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT, error)
    );
  }
}

function* getArchiveContact() {
  try {
    const response: Promise<any> = yield call(getArchiveContactApi);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.GET_ARCHIVE_CONTACT, response)
    );
  } catch (error: any) {
    yield put(
      chatsApiResponseError(ChatsActionTypes.GET_ARCHIVE_CONTACT, error)
    );
  }
}

function* toggleArchiveContact({ payload: id }: any) {
  try {
    const response: Promise<any> = yield call(toggleArchiveContactApi, id);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT, response)
    );
    yield call(showSuccessNotification, response + "");
  } catch (error: any) {
    yield call(showErrorNotification, error + "");
    yield put(
      chatsApiResponseError(ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT, error)
    );
  }
}

function* readConversation({ payload: id }: any) {
  try {
    // console.log('readConversation:', id);
    const response: Promise<any> = yield call(readConversationApi, id);
    // console.log('readConversation:', response);
    yield put(
      chatsApiResponseSuccess(ChatsActionTypes.READ_CONVERSATION, response)
    );
    // yield put(getDirectMessagesAction());
    // yield put(getFavouritesAction());
    // yield put(getChannelsAction());
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.READ_CONVERSATION, error));
  }
}

function* deleteImage({ payload: { userId, messageId, imageId } }: any) {
  try {
    const response: Promise<any> = yield call(
      deleteImageApi,
      userId,
      messageId,
      imageId
    );
    yield put(chatsApiResponseSuccess(ChatsActionTypes.DELETE_IMAGE, response));
  } catch (error: any) {
    yield put(chatsApiResponseError(ChatsActionTypes.DELETE_IMAGE, error));
  }
}

export function* watchGetFavourites() {
  yield takeEvery(ChatsActionTypes.GET_FAVOURITES, getFavourites);
}

// export function* watchGetChatRoomLists() {
//   yield takeEvery(ChatsActionTypes.GET_CHAT_ROOM_LIST, getChatRoomLists);
// }

export function* watchLoadCustomerContent() {
  // yield takeEvery(ChatsActionTypes.LOAD_CUSTOMER_CONTENT, loadCustomerContent);
  yield takeLatest(ChatsActionTypes.LOAD_CUSTOMER_CONTENT, loadCustomerContent);
}

export function* watchGetAllContentCount() {
  yield takeLatest(ChatsActionTypes.GET_CONTENT_UNREAD_COUNT_ALL, getAllContentCount);
}

export function* watchSetRespEmoji() {
  yield takeEvery(ChatsActionTypes.SET_RESP_EMOJI, setRespEmoji);
}

export function* watchGetContentUnreadCount() {
  yield takeEvery(ChatsActionTypes.GET_CONTENT_UNREAD_COUNT, getContentUnreadCount);
}


export function* watchGetDirectMessages() {
  yield takeEvery(ChatsActionTypes.GET_DIRECT_MESSAGES, getDirectMessages);
}
export function* watchGetChannels() {
  yield takeEvery(ChatsActionTypes.GET_CHANNELS, getChannels);
}
export function* watchAddContacts() {
  yield takeEvery(ChatsActionTypes.ADD_CONTACTS, addContacts);
}
export function* watchCreateChannel() {
  yield takeEvery(ChatsActionTypes.CREATE_CHANNEL, createChannel);
}
export function* watchGetChatUserDetails() {
  yield takeEvery(ChatsActionTypes.GET_CHAT_USER_DETAILS, getChatUserDetails);
}
export function* watchGetChatUserDetails2s() {
  yield takeEvery(ChatsActionTypes.GET_CHAT_USER_DETAILS_2S, getChatUserDetails2s);
}
export function* watchGetLastGroupChatInfoOfMember() {
  yield takeEvery(ChatsActionTypes.GET_LAST_GROUP_CHAT_INFO_OF_MEMBER, getLastGroupChatInfoOfMember);
}
export function* watchDelUserFromGroup() {
  yield takeEvery(ChatsActionTypes.DEL_USER_FROM_GROUP, delUserFromGroup);
}
export function* watchErpGetCustomerTask() {
  yield takeLatest(ChatsActionTypes.ERP_GET_CUSTOMER_TASK, erpGetCustomerTask);
}
export function* watchErpGetPrevTopNoVolume() {
  yield takeLatest(ChatsActionTypes.ERP_GET_PREV_TOP_NO_VOLUME, erpGetPrevTopNoVolume);
}

export function* watchErpCateSizeNotSaleMoreThan45() {
  yield takeLatest(ChatsActionTypes.ERP_CATE_SIZE_NOT_SALE_MORE_THAN_45, erpCateSizeNotSaleMoreThan45);
}
export function* watchErpCateInterestNotSale() {
  yield takeLatest(ChatsActionTypes.ERP_CATE_INTEREST_NOT_SALE, erpCateInterestNotSale);
}
export function* watchErpCateNotSaleMoreThan60() {
  yield takeLatest(ChatsActionTypes.ERP_CATE_NOT_SALE_MORE_THAN_60, erpCateNotSaleMoreThan60);
}

export function* watchFindForFilterChatroomSale() {
  yield takeLatest(ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_SALE, findForFilterChatroom);
}

export function* watchFindForFilterChatroomCs() {
  yield takeLatest(ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_CS, findForFilterChatroom);
}

export function* watchFindForFilterChatroomProvince() {
  yield takeLatest(ChatsActionTypes.FIND_FOR_FILTER_CHATROOM_PROVINCE, findForFilterChatroom);
}

export function* watchSearchChat() {
  yield takeLatest(ChatsActionTypes.SEARCH_CHAT, searchChat);
}

export function* watchQuickReplyLoadAll() {
  yield takeLatest(ChatsActionTypes.QUICK_REPLY_LOAD_ALL, quickReplyLoadAll);
}

export function* watchAddUserToGroup() {
  yield takeEvery(ChatsActionTypes.ADD_USER_TO_GROUP, addUserToGroup);
}
export function* watchViewMsgMember() {
  yield takeEvery(ChatsActionTypes.VIEW_MSG_MEMBER, viewMsgMember);
}
export function* watchGetContentList() {
  yield takeLatest(ChatsActionTypes.CHANGE_SELECTED_CONTENT_TITLE, getContentList);
}
export function* watchGetChatUserConversations() {
  // yield takeEvery(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS, getChatUserConversations);
  yield takeLatest(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS, getChatUserConversations); // 20250715
}
export function* watchGetChatUserConversationsPrev() {
  yield takeEvery(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_PREV, getChatUserConversationsPrev);
}
// export function* watchSetTypingText() {
//   yield takeLatest(ChatsActionTypes.SET_TYPING_TEXT, setTypingText);
// }
export function* watchGetChatUserConversationsNext() {
  yield takeEvery(ChatsActionTypes.GET_CHAT_USER_CONVERSATIONS_NEXT, getChatUserConversationsNext);
}
export function* watchOnSendMessage() {
  yield takeEvery(ChatsActionTypes.ON_SEND_MESSAGE, onSendMessage);
}
export function* watchReceiveMessage() {
  yield takeEvery(ChatsActionTypes.RECEIVE_MESSAGE, receiveMessage);
}
export function* watchReadMessage() {
  yield takeEvery(ChatsActionTypes.READ_MESSAGE, readMessage);
}
export function* watchDeleteMessage2s() {
  yield takeEvery(ChatsActionTypes.DELETE_MESSAGE_2S, deleteMessage2s);
}
export function* watchaDDMessage2s() {
  yield takeEvery(ChatsActionTypes.ADD_MESSAGE_2S, addMessage2s);
}
export function* watchReceiveMessageFromUser() {
  yield takeEvery(
    ChatsActionTypes.RECEIVE_MESSAGE_FROM_USER,
    receiveMessageFromUser
  );
}
export function* watchDeleteMessage() {
  yield takeEvery(ChatsActionTypes.DELETE_MESSAGE, deleteMessage);
}
export function* watchForwardMessage() {
  yield takeEvery(ChatsActionTypes.FORWARD_MESSAGE, forwardMessage);
}
export function* watchDeleteUserMessages() {
  yield takeEvery(ChatsActionTypes.DELETE_USER_MESSAGES, deleteUserMessages);
}
export function* watchGetChannelDetails() {
  yield takeEvery(ChatsActionTypes.GET_CHANNEL_DETAILS, getChannelDetails);
}
export function* watchToggleFavouriteContact() {
  yield takeEvery(
    ChatsActionTypes.TOGGLE_FAVOURITE_CONTACT,
    toggleFavouriteContact
  );
}
export function* watchGetArchiveContact() {
  yield takeEvery(ChatsActionTypes.GET_ARCHIVE_CONTACT, getArchiveContact);
}
export function* watchToggleArchiveContact() {
  yield takeEvery(
    ChatsActionTypes.TOGGLE_ARCHIVE_CONTACT,
    toggleArchiveContact
  );
}
export function* watchReadConversation() {
  yield takeEvery(ChatsActionTypes.READ_CONVERSATION, readConversation);
}
export function* watchDeleteImage() {
  yield takeEvery(ChatsActionTypes.DELETE_IMAGE, deleteImage);
}

function* chatsSaga() {
  yield all([
    fork(watchGetFavourites),
    // fork(watchGetChatRoomLists),
    fork(watchLoadCustomerContent),
    fork(watchGetContentUnreadCount),
    fork(watchGetAllContentCount),
    fork(watchGetDirectMessages),
    fork(watchGetChannels),
    fork(watchAddContacts),
    fork(watchCreateChannel),
    fork(watchGetChatUserDetails),
    fork(watchGetChatUserDetails2s),
    fork(watchGetLastGroupChatInfoOfMember),
    fork(watchDelUserFromGroup),
    fork(watchAddUserToGroup),
    fork(watchViewMsgMember),
    fork(watchGetChatUserConversations), fork(watchGetChatUserConversationsPrev), fork(watchGetChatUserConversationsNext),
    fork(watchOnSendMessage),
    fork(watchReceiveMessage),
    fork(watchReadMessage),
    fork(watchDeleteMessage2s),
    fork(watchaDDMessage2s),
    fork(watchReceiveMessageFromUser),
    fork(watchDeleteMessage),
    fork(watchForwardMessage),
    fork(watchDeleteUserMessages),
    fork(watchGetChannelDetails),
    fork(watchToggleFavouriteContact),
    fork(watchGetArchiveContact),
    fork(watchToggleArchiveContact),
    fork(watchReadConversation),
    fork(watchDeleteImage),
    fork(watchGetContentList),
    fork(watchSetRespEmoji),
    fork(watchErpGetCustomerTask),
    fork(watchErpGetPrevTopNoVolume),
    fork(watchErpCateSizeNotSaleMoreThan45),
    fork(watchErpCateInterestNotSale),
    fork(watchErpCateNotSaleMoreThan60),
    fork(watchFindForFilterChatroomSale),
    fork(watchFindForFilterChatroomCs),
    fork(watchFindForFilterChatroomProvince),
    fork(watchSearchChat),
    fork(watchQuickReplyLoadAll),
    // fork(watchSetTypingText),
  ]);
}

export default chatsSaga;
